import { SectionTitle } from '@modules/talents/components';
import { SectionCard } from '@modules/talents/components/SectionCard';
import { Box, Typography } from '@mui/material';


const JobOfferAbout = ({ pro, jobOffer, loading }: { pro: any, jobOffer: any, onSubmit?: () => Promise<void>, loading?: boolean }) => {
  
    return (
        <SectionCard>
            <Box display="flex" flexDirection="column" gap="4px">
                <SectionTitle title="À Propos" />
                <Typography
                    sx={{
                        fontSize: '16px',
                        lineHeight: '24px',
                        fontWeight: 400,
                        whiteSpace: 'pre-line'
                    }}
                    dangerouslySetInnerHTML={{
                        __html: jobOffer?.brand?.description || jobOffer?.pro?.description || 'Aucune description fournie par le recruteur.'
                    }} />
            </Box>
        </SectionCard>
    );
};

export default JobOfferAbout;
